import { render, staticRenderFns } from "./ElementTable.vue?vue&type=template&id=89c6e692&"
import script from "./ElementTable.vue?vue&type=script&lang=ts&"
export * from "./ElementTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports